module.exports = __webpack_public_path__ + "static/media/filter.850a821b.svg";